/* unplugin-vue-components disabled */import __unplugin_components_0 from 'C:/Users/will/workspace/risesun/zhxy/EvaluateJYJPC/src/components/SvgIcon/index.vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["title"];
const _hoisted_4 = ["title"];
import { isExternal } from "@/utils/validate";
import AppLink from "./Link";
import { getNormalPath } from "@/utils/sunrise.js";
export default {
  __name: 'SidebarItem',
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    const onlyOneChild = ref({});
    function hasOneShowingChild(children = [], parent) {
      if (!children) {
        children = [];
      }
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          onlyOneChild.value = item;
          return true;
        }
      });

      // 当只有一个子路由时，默认显示子路由
      if (showingChildren.length === 1) {
        return true;
      }

      // 如果没有要显示的子路由，则显示父路由
      if (showingChildren.length === 0) {
        onlyOneChild.value = {
          ...parent,
          path: "",
          noShowingChildren: true
        };
        return true;
      }
      return false;
    }
    function resolvePath(routePath, routeQuery) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(props.basePath)) {
        return props.basePath;
      }
      if (routeQuery) {
        let query = JSON.parse(routeQuery);
        return {
          path: getNormalPath(props.basePath + "/" + routePath),
          query: query
        };
      }
      return getNormalPath(props.basePath + "/" + routePath);
    }
    function hasTitle(title) {
      if (title.length > 5) {
        return title;
      } else {
        return "";
      }
    }
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_svg_icon = __unplugin_components_0;
      const _component_sidebar_item = _resolveComponent("sidebar-item", true);
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      return !__props.item.hidden ? (_openBlock(), _createElementBlock("div", _hoisted_1, [hasOneShowingChild(__props.item.children, __props.item) && (!_unref(onlyOneChild).children || _unref(onlyOneChild).noShowingChildren) && !__props.item.alwaysShow ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_unref(onlyOneChild).meta ? (_openBlock(), _createBlock(_unref(AppLink), {
        key: 0,
        to: resolvePath(_unref(onlyOneChild).path, _unref(onlyOneChild).query)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: resolvePath(_unref(onlyOneChild).path),
          class: _normalizeClass({
            'submenu-title-noDropdown': !__props.isNest
          })
        }, {
          title: _withCtx(() => [_createElementVNode("span", {
            class: "menu-title",
            title: hasTitle(_unref(onlyOneChild).meta.title)
          }, _toDisplayString(_unref(onlyOneChild).meta.title), 9, _hoisted_3)]),
          default: _withCtx(() => [_unref(onlyOneChild).meta.icon || __props.item.meta && __props.item.meta.icon ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            style: {
              "height": "1rem",
              "width": "1rem"
            },
            src: _unref(onlyOneChild).meta.icon || __props.item.meta && __props.item.meta.icon ? require(`@/assets/images/shouye/${_unref(onlyOneChild).meta.icon || __props.item.meta && __props.item.meta.icon}`) : '',
            alt: ""
          }, null, 8, _hoisted_2)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["index", "class"])]),
        _: 1
      }, 8, ["to"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 1,
        ref: "subMenu",
        index: resolvePath(__props.item.path),
        "popper-class": "pro_menu_css"
      }, _createSlots({
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, child => {
          return _openBlock(), _createBlock(_component_sidebar_item, {
            key: child.path,
            "is-nest": true,
            item: child,
            "base-path": resolvePath(child.path),
            class: "nest-menu"
          }, null, 8, ["item", "base-path"]);
        }), 128))]),
        _: 2
      }, [__props.item.meta ? {
        name: "title",
        fn: _withCtx(() => [__props.item.meta && __props.item.meta.icon ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 0,
          "icon-class": __props.item.meta && __props.item.meta.icon
        }, null, 8, ["icon-class"])) : _createCommentVNode("", true), _createElementVNode("span", {
          class: "menu-title",
          title: hasTitle(__props.item.meta.title)
        }, _toDisplayString(__props.item.meta.title), 9, _hoisted_4)]),
        key: "0"
      } : undefined]), 1032, ["index"]))])) : _createCommentVNode("", true);
    };
  }
};